import React, { useEffect, useState } from 'react';
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { ArrowLeft, ArrowRightCr, Close, UploadIcon } from "../../../icons/icons";
import { useTranslation } from "react-i18next";
import Resizer from "react-image-file-resizer";

const ImageUploader = ({ title, name, en, onChange, defaultValue, id = '1', onClear }) => {
  const [currentImage, setCurrentImage] = useState(null);
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [src, setSrc] = useState("https://api.flysepehr.com/storage" + defaultValue ?? "");

  const { t } = useTranslation()
  function handleTakePhoto(dataUri) {
    setSrc(dataUri)
    onChange({ name: name, value: dataUri })
    setOpen(false)
    setCurrentImage(null)
  }

  useEffect(() => {
    if (typeof defaultValue=='string' && !defaultValue?.includes('http'))
      setSrc("https://api.flysepehr.com/storage" + defaultValue ?? "")
  }, [defaultValue])

  useEffect(() => {
    setCurrentImage(null);
  }, [onClear])

  const resizeFile = (file) => {
    return new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1000,
        1000,
        "JPEG",
        50,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    })
  }
  const upload = async (e) => {
    try {
      const file = e.target.files[0];

      if (file?.type?.includes("image")) {
        const image = await resizeFile(file);
        setSrc(image)
        setCurrentImage(image);
      } else {
        setSrc(file)
        setCurrentImage(file);
      }
      onChange({ name: name, value: e.target.files[0] })
    } catch (err) {
    
      console.log(err);
    }
  }
  const handleImageDelete = () => {
    setCurrentImage(null);
  };
  const handleName = (defaultValue) => {
    const pure = defaultValue?.split("/")
    return pure[pure?.length - 1]
  }

  console.log({ currentImage, defaultValue  , title , id, src })


  return (
    <div className="w-full  flex justify-center" title={name}>

      <div className="relative w-full h-[157px]">
        <label htmlFor={name + id} className="flex text-gray-700 font-bold  justify-center items-center cursor-pointer w-full h-full">
          <div className={`text-xs md:text-base  text-${error ? "orange-500 border-orange-500" : "gray-800"} border border-dashed border-1 w-full h-full flex justify-center items-center rounded-lg`}>
            {
              (currentImage || defaultValue ) ?
                <div className="bg-white rounded-lg overflow-hidden self-stretch gap-2 flex flex-col items-stretch p-2">
                  {
                    currentImage?.type === "application/pdf" || (typeof defaultValue === "string" && defaultValue?.includes("pdf")) ?
                      <span className={"absolute top-[40%] text-center"}>
                        {currentImage?.name || handleName(defaultValue)}
                      </span>
                      :
                      <>
                        <span className='text-center text-sm w-full text-gray-500'>{title}</span>
                        { (typeof currentImage =='string' || typeof src  =='string')
                          ? <img src={currentImage || (defaultValue ? src : "")} alt="Uploaded" className="w-32 aspect-square object-contain  " />
                          : <div dir='rtl' className='flex flex-col w-32 aspect-square object-contain rounded-xl bg-gray-50  justify-center items-center text-sm  text-center text-ellipsis'  alt="Uploaded">
                            {src ? src?.name?.split('.')?.toReversed().slice(0,2).reverse().join('.') : t('file')}
                            </div>}
                      </>

                  }
                  <div className="p-4">
                    <button
                      onClick={handleImageDelete}
                      className="bg-lighterBlue text-white px-3 py-1 rounded text-xs"
                    >
                      حذف
                    </button>
                  </div>
                </div>
                :
                <div className={"flex justify-center items-center flex-col gap-2"}>
                  <div>
                    <UploadIcon />
                  </div>
                  <div className={"flex items-center"}>
                    <span className={"px-1 font-medium text-sm"}>
                      {error ? "فرمت اشتباه" : title}
                    </span>
                    <span className={"px-1 font-medium text-sm text-main"}>
                      {en ? "Choose File" : t("chooseFile")}
                    </span>
                  </div>
                  <div className={"text-gray-300 font-medium text-sm"}>
                    {"jpg, png, pdf"}
                  </div>
                </div>
            }
          </div>
        </label>
        <input
          id={name + id}
          type="file"
          onChange={upload}
          accept=".pdf,.jpg,.jpeg,.png"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline absolute opacity-0 -z-10 !w-0"
        />

        {/*<div onClick={() => setOpen(true)} className={"md:hidden absolute bg-main p-2 text-xs text-white rounded-sm top-2 z-10"}>*/}
        {/*  باز کردن دوربین*/}
        {/*</div>*/}
      </div>
      {
        open &&
        <>
          <div onClick={() => setOpen(false)} className={"fixed text-white rounded-sm top-3 z-50 right-3 opacity-80"}>
            <ArrowRightCr />
          </div>
          {/*<div onClick={() => setOpen(false)} className={" absolute text-white rounded-sm top-3 z-30 right-0 opacity-80 bg-black w-full h-10"}/>*/}
        </>
      }

    </div>
  );
};

export default ImageUploader;
